// https://github.com/IdentityModel/oidc-client-js
const noOpLogger = {
    debug() { },
    info() { },
    warn() { },
    error() { }
};
export class Log {
    static NONE = 0;
    static ERROR = 1;
    static WARN = 2;
    static INFO = 3;
    static DEBUG = 4;
    static level = Log.WARN;
    static logger;
    static reset() {
        this.level = Log.INFO;
        this.logger = noOpLogger;
    }
    static debug = (...msg) => {
        if (Log.level >= Log.DEBUG) {
            Log.logger.debug('DEBUG:', ...msg);
        }
    };
    static info = (...msg) => {
        if (Log.level >= Log.INFO) {
            Log.logger.info('INFO:', ...msg);
        }
    };
    static warn = (...msg) => {
        if (Log.level >= Log.WARN) {
            Log.logger.warn('WARN:', ...msg);
        }
    };
    static error = (...msg) => {
        if (Log.level >= Log.ERROR) {
            Log.logger.error('ERROR:', ...msg);
        }
    };
}
export const ConfigureLogger = (level, logger = console) => {
    Log.level = level;
    Log.logger = logger;
};
Log.reset();
